import { fetchMe, updateMe } from "@rpforms/shared/build/actions/users";
import { PrimaryButton } from "@rpforms/shared/build/components/Button";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { SettingsHeadline } from "./SettingsPage";

const ProfileSettingsPage = () => {
    const [displayName, setDisplayName] = useState("");
    const [mailSignature, setMailSignature] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        fetchMe().then((me) => {
            setDisplayName(me.display_name || "");
            setMailSignature(me.mail_signature || "");
        });
    }, []);

    const handleSave = async () => {
        setSaving(true);
        try {
            const me = await updateMe({
                display_name: displayName,
                mail_signature: mailSignature,
            });
            setDisplayName(me.display_name || "");
            setMailSignature(me.mail_signature || "");
            toast.success("Profil gespeichert");
        } catch (err) {
            toast.error("Profil konnte nicht gespeichert werden");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div>
            <SettingsHeadline>
                <span>Mein Profil</span>
            </SettingsHeadline>
            <div className="form-group">
                <label htmlFor="profile-display-name">Anzeigename</label>
                <input
                    id="profile-display-name"
                    type="text"
                    className="form-control"
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label htmlFor="profile-mail-signature">Mail-Signatur</label>
                <textarea
                    id="profile-mail-signature"
                    className="form-control"
                    rows={6}
                    value={mailSignature}
                    onChange={(e) => setMailSignature(e.target.value)}
                />
            </div>
            <PrimaryButton type="button" onClick={handleSave} disabled={saving}>
                Speichern
            </PrimaryButton>
        </div>
    );
};

export default withRouter(ProfileSettingsPage);
